import { BrowserRouter, Routes, Route } from "react-router-dom";
import React from 'react';

import LoginPage from './telas/LoginPage';
import UserRegistration from './telas/UserRegistration';
import CadastroEmpresa from './telas/CadastroEmpresa';
import HomePage from './telas/HomePage';
import CadastroServico from './telas/CadastroServico';
import Clientes from './telas/Clientes';
import Procuracao from './telas/Procuracao';
import Relatorios from './telas/Relatorios';
import SettingsPage from "./telas/SettingsPage";
import OrdemServicoView from './telas/OrdemServicoView';
import OrdemServico from './telas/OrdemServico';
import ServerInfo from './telas/ServerInfo';
import BackupManager from './telas/BackupManager';
import Despesas from './telas/Despesas';
import Agenda from './telas/Agenda';
import Contratos from './telas/Contratos';
import DocumentosComplementares from './telas/DocumentosComplementares';
import RequerimentoDetranPage from './telas/RequerimentoDetranPage';
import ImportarCrlv from './telas/ImportarCrlv';
import SelecionarEmpresa from './telas/SelecionarEmpresa';
import Processos from './telas/Processos';


function App() {
  return (
    <BrowserRouter>
      <Routes>
      <Route index path="/login" element={<LoginPage />} />
        <Route path="/" element={<LoginPage />} />
        <Route path="/usuarios" element={<UserRegistration />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/cadastroEmpresas" element={<CadastroEmpresa />} />
        <Route path="/cadastroServico" element={<CadastroServico />} />
        <Route path="/clientes" element={<Clientes/>} />
        <Route path="/procuracao" element={<Procuracao/>} />
        <Route path="/relatorios" element={<Relatorios/>} />
        <Route path="/settings" element={<SettingsPage/>} />
        <Route path="/ordemServico" element={<OrdemServicoView/>} />
        <Route path="/criar-editar-ordemServico/:id?" element={<OrdemServico/>} />
        <Route path="/server-info" element={<ServerInfo/>} />
        <Route path="/backups-crons" element={<BackupManager/>} />
        <Route path="/despesas" element={<Despesas/>} />
        <Route path="/agenda" element={<Agenda/>} />
        <Route path="/contratos" element={<Contratos/>} />
        <Route path="/documentos-complementares/:tipo?" element={<DocumentosComplementares/>} />
        <Route path="/requerimento-detran" element={<RequerimentoDetranPage/>} />
        <Route path="/importar-crlv" element={<ImportarCrlv/>} />
        <Route path="/selecionar-empresa" element={<SelecionarEmpresa/>} />
        <Route path="/processos" element={<Processos/>} />
      </Routes>
    </BrowserRouter>

  );
}

export default App;
